exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{font-size:10px;padding:8px 15px;background-color:#131718;color:#fff;display:flex;flex:0 0 auto;justify-content:space-between;text-transform:uppercase}.footer__brand{align-self:flex-start}.footer__links{align-self:flex-end}", ""]);

// exports
